import { CanceledError } from 'axios'
import { isSessionExpired } from '~/atoms/SessionExpiredState'

import type { ApisauceInstance } from '@mangovoice/apisauce'

/**
 * Cancels requests before they are sent while the session is expired, so
 * polling stops sending dead tokens. apisauce reports them as `CANCEL_ERROR`.
 */
export const blockRequestsWhileSessionExpired = (
  instances: ApisauceInstance[],
) => {
  instances.forEach((instance) => {
    instance.axiosInstance.interceptors.request.use((config) => {
      if (isSessionExpired()) {
        throw new CanceledError('Session expired', config)
      }
      return config
    })
  })
}
